import {
  CustomEvents,
  translations,
  CameraStates,
  game,
  modes,
  playersManager,
  trainingManager,
  hints,
  requestManager,
  cameraManager,
  corePhasesManager,
  type PlayerInfoForTable,
  audioManager
} from '@powerplay/core-minigames'
import {
  loadingCircleState,
  loadingState,
  tutorialCoreState,
  translationsSSM as t
} from '@powerplay/core-minigames-ui-ssm'
import { tutorialFlow } from '@/app/modes/tutorial/TutorialFlow'
import { translatesReplacements } from '@/app/config'
import {
  instructionsState,
  tableState,
  blurState,
  trainingResultsState,
  tournamentState
} from '@/stores'
import {
  AudioGroups,
  AudioNames
} from '@/app/types'
import { stateManager } from '../app/StateManager'
import { disciplinePhasesManager } from '@/app/phases/DisciplinePhasesManager'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initiateListeners = (vm: any) => {

  // Listener for language download
  window.addEventListener(CustomEvents.translations, () => {

    if (Number(import.meta.env.VITE_APP_LOCAL)) {

      translations.setTranslations(t, translatesReplacements)

    }

    vm.$i18n.setLocaleMessage('lang', translations.getTranslations())

    // musime zmenit hint v loadingu
    hints.setSpecificHintsCountForDiscipline(2)
    const hint = hints.getHintText(requestManager.disciplineID)

    loadingState().$patch({
      showLoading: true,
      hintText: vm.$t(hint)
    })

  })

  // Listener for game start event
  window.addEventListener(CustomEvents.gameStart, () => {

    if (!modes.isTutorial()) {

      loadingState().showLoading = false

    }

    if (!modes.isTutorial()) audioManager.play(AudioNames.audienceIntroNoise)

  })

  // Listener for game start instruction phase
  window.addEventListener(CustomEvents.startInstructionsPhase, () => {

    instructionsState().$patch({
      showInstructions: true,
      showButton: false
    })
    cameraManager.setState(CameraStates.table)
    cameraManager.playTween(true)
    game.renderScene()

  })

  // Listener pre tutorial Typewrite
  window.addEventListener(CustomEvents.typeWrite, () => {

    if (!modes.isTutorial()) return

    tutorialCoreState().typeWriter = false

  })

  // Listener pre tutorial game event
  window.addEventListener(CustomEvents.tutorialGameEvent, () => {

    if (!modes.isTutorial()) return

    tutorialFlow.checkInput()

  })

  // Listener for game intro start event
  window.addEventListener(CustomEvents.startIntroPhase, () => {

    // audioManager.play(AudioNames.audienceNoise)
    if (modes.isTutorial()) return

    tableState().$patch({
      competitionText: modes.isTrainingMode() ?
        vm.$t('level').replace('%s', trainingManager.level) :
        `tableText${modes.mode}`,
      showTable: true
    })

    if (!modes.isTutorial() && !modes.isTrainingMode()) {

      audioManager.stopAudioByGroup(AudioGroups.commentators)
      audioManager.play(AudioNames.commentatorIntro)

    }

  })

  // Listener for game start listing phase
  window.addEventListener(CustomEvents.startStartListPhase, () => {

    if (modes.isTutorial()) return

    blurState().$patch({
      isActive: true,
      isTable: true
    })

    const data = playersManager.getDataForTable()
    console.log(data)
    tableState().$patch({
      dataTable: data,
      resultText: 'startList',
      isStartList: true,
      activeState: true,
      javelinType: false
    })

  })

  // Listener for game start discipline phase
  window.addEventListener(CustomEvents.startDisciplinePhase, () => {

    if (modes.isTutorial()) return

    blurState().$patch({
      isActive: false,
      isTable: false
    })
    tableState().$patch({
      showTable: false,
      activeState: false,
      isStartList: false
    })

  })

  // Listener for game start provisional results phase
  window.addEventListener(CustomEvents.startProvisionalResultsPhase, () => {

    if (modes.isTutorial()) return

    stateManager.hideAttemptsTable()

    blurState().$patch({
      isActive: true,
      isTable: true
    })

    playersManager.setStandings(
      2,
      modes.isTournament() && corePhasesManager.disciplineActualAttempt <= 1,
      modes.isTournament() && corePhasesManager.disciplineActualAttempt <= 1
    )

    const dataForTable = JSON.parse(JSON.stringify(playersManager.getStandings())) as PlayerInfoForTable[]

    // musime si zaznacit najlepsi vysledok, aby sme to potom mohli zobrazit
    tournamentState().bestResult = dataForTable[0].result ?? '-'
    if (tournamentState().bestResult === '') tournamentState().bestResult = '-'


    dataForTable.forEach(data => {

      data.results = data?.resultsFull?.map(result => {

        if (modes.isTournament() && corePhasesManager.disciplineActualAttempt <= 1) return ''

        if (result.second === '1') return 'X'
        if (result.third === '1') return '-'
        if (result.main === '-1') return ''
        return Number(result.main).toFixed(2)

      }) || []
      if (data.results.length < corePhasesManager.disciplineAttemptsCount) {

        for (let i = 0; i < 3; i++) {

          data.results.push('')

        }

      }

    })

    tableState().$patch({
      showTable: true,
      activeState: true,
      resultText: 'provisionalResults',
      dataTable: dataForTable,
      javelinType: true
    })

    if (!audioManager.isAudioGroupPlaying(AudioGroups.commentators)) {

      audioManager.play(AudioNames.commentatorProvisionalStandings)

    }

  })

  // Listener for game start final standings phase
  window.addEventListener(CustomEvents.startFinalStandingsPhase, () => {

    if (modes.isTutorial()) return

    stateManager.hideAttemptsTable()

    // if (!audioManager.isAudioGroupPlaying(AudioGroups.commentators)) {

    //   audioManager.play(AudioNames.commentatorFinalResults)

    // }

    if (modes.isTournament() && !disciplinePhasesManager.tournamentDataSet) return

    blurState().$patch({
      isActive: true,
      isTable: true
    })

    if (modes.isTournament()) playersManager.setStandings()

    const dataForTable = JSON.parse(JSON.stringify(playersManager.getStandings())) as PlayerInfoForTable[]
    dataForTable.forEach(data => {

      data.results = data?.resultsFull?.map(result => {

        if (result.second === '1') return 'X'
        if (result.third === '1') return '-'
        if (result.main === '-1') return ''
        return Number(result.main).toFixed(2)

      } ) || []

    })

    tableState().$patch({
      competitionText: modes.isTrainingMode() ?
        vm.$t('level').replace('%s', trainingManager.level) :
        `tableText${modes.mode}`,
      dataTable: dataForTable,
      resultText: 'finalStandings',
      showTable: true,
      activeState: true,
      javelinType: true
    })

    if (!audioManager.isAudioGroupPlaying(AudioGroups.commentators)) {

      audioManager.play(AudioNames.commentatorFinalResults)

    }

  })

  // Listener for game start final training phase
  window.addEventListener(CustomEvents.startFinalTrainingPhase, () => {

    if (modes.isTutorial()) return
    trainingResultsState().showResults = true

  })

  // Listener pre to, aby sme vedeli, ze su vsetky konecne requesty zbehnute
  window.addEventListener(CustomEvents.allRequestDoneOnEnd, () => {

    if (modes.isTournament() && Number(import.meta.env.VITE_APP_LOCAL) === 1) return
    stateManager.afterAllRequestsDone()

  })

  /** Listener pre zobrazenie loading circle po kliknuti na final redirect */
  window.addEventListener(CustomEvents.finalRedirectDone, () => {

    console.log('mal by ist redirect loading')
    loadingCircleState().isActive = true

  })

}
